import React, { useEffect, useState } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { LocalStorageKeys } from "../core";

const ProtectedRoute = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(() => {
    return !!localStorage.getItem(LocalStorageKeys.adminToken);
  });

  useEffect(() => {
    const handleStorageChange = (e) => {
      if (e.key === LocalStorageKeys.adminToken) {
        setIsAuthenticated(!!e.newValue);
      }
    };

    const intervalCheck = setInterval(() => {
      const tokenExists = !!localStorage.getItem(LocalStorageKeys.adminToken);
      if (isAuthenticated !== tokenExists) {
        setIsAuthenticated(tokenExists);
      }
    }, 1000); 
    
    window.addEventListener("storage", handleStorageChange);

    return () => {
      window.removeEventListener("storage", handleStorageChange);
      clearInterval(intervalCheck);
    };
  }, [isAuthenticated]);
  
  return isAuthenticated ? <Outlet /> : <Navigate to="/login" replace />;
};

export default ProtectedRoute;